export const isMobile = () => {
  return window.matchMedia("(max-width: 767px)").matches
}
export const isDesktop = () => {
  return window.matchMedia("(min-width: 1024px)").matches
}

export const getViewPortWidth = () => {
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
}

export const getViewPortHeight = () => {
  return Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
}

export const getRootVariable = (name) => {
  // Example --color-grey
  return getComputedStyle(document.documentElement).getPropertyValue(name)
}


export const setGlobalChartConfig = () => {

  if(Chart)
  {
    // Global config
    Chart.defaults.font = {
      family: "Arial, 'Helvetica', 'Arial', sans-serif",
      size: 13,
      weight: "normal",
    }
    Chart.defaults.color = getRootVariable("--color-gray-dark");
  }

}

export const getHEXAlpha = (color, opacity) => 
{
  // coerce values so ti is between 0 and 1.
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + _opacity.toString(16).toUpperCase();
}

export const convertHEXtoRGB = (hex) => 
{

  if(!hex.includes("#"))
    return hex;

  hex = hex.replace("#","");

  var aRgbHex = hex.match(/.{1,2}/g);
  var aRgb = `rgb(${parseInt(aRgbHex[0], 16)},${parseInt(aRgbHex[1], 16)},${parseInt(aRgbHex[2], 16)})`;

  return aRgb;
}

export const setRGBTransparency = (color) => 
{
  if(color.includes("rgba"))
    return color;

  var rgba = color.replace(')', ',0.2)');
  rgba = rgba.replace('rgb', 'rgba');
  return rgba;
}
